(function () {

  // ─── 1. HIDE QTY SELECTOR ON SOLD OUT ───────────────────────────────────────

  function updateQtySelectorVisibility() {
    document.querySelectorAll('quantity-selector-component').forEach((component) => {
      const wrapper = component.closest('.quantity-selector-wrapper') || component.parentElement;
      if (!wrapper) return;

      // Check if the add to cart button is sold out
      const productForm = component.closest('product-form-component');
      const addToCartButton = productForm?.querySelector('[ref="addToCartButton"]');

      const isSoldOut =
        addToCartButton?.disabled === true ||
        addToCartButton?.textContent?.trim().toLowerCase().includes('sold out') ||
        !!productForm?.querySelector('button[name="add"][disabled]');

      wrapper.style.display = isSoldOut ? 'none' : '';
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', updateQtySelectorVisibility);

  // Re-run on variant switches (sold out state changes per variant)
  const variantObserver = new MutationObserver(updateQtySelectorVisibility);
  variantObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'class']
  });

  // ─── 2. RESET QTY SELECTOR ON STOCK LIMIT ERROR ─────────────────────────────

  async function fetchCartQtyForVariant(variantId) {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const item = cart.items.find((i) => i.variant_id.toString() === variantId.toString());
      return item ? item.quantity : 0;
    } catch (e) {
      return 0;
    }
  }

  async function resetQtySelector(component) {
    const variantId = component.getAttribute('data-variant-id');
    if (!variantId) return;

    const cartQty = await fetchCartQtyForVariant(variantId);
    if (cartQty <= 0) return;

    if (typeof component.setValue === 'function') {
      component.setValue(String(cartQty));
    }
    if (typeof component.setCartQuantity === 'function') {
      component.setCartQuantity(cartQty);
    }
    if (typeof component.updateButtonStates === 'function') {
      component.updateButtonStates();
    }
  }

  const errorObserver = new MutationObserver(() => {
    const errorEl = document.querySelector('[ref="addToCartTextError"]:not(.hidden)');
    if (errorEl && !errorEl._chakoreResetting) {
      errorEl._chakoreResetting = true;
      setTimeout(async () => {
        await Promise.all(
          [...document.querySelectorAll('quantity-selector-component')].map(resetQtySelector)
        );
        const flagObserver = new MutationObserver(() => {
          if (errorEl.classList.contains('hidden')) {
            errorEl._chakoreResetting = false;
            flagObserver.disconnect();
          }
        });
        flagObserver.observe(errorEl, { attributes: true, attributeFilter: ['class'] });
      }, 350);
    }
  });

  errorObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

})();
